import { takeLatest } from 'redux-saga/effects';
import {
	getStaffOnlineStatusSuccess, getStaffOnlineStatusFail,
	getClientSummaryCardsSuccess, getClientSummaryCardsFail,
	getClientActionRequiredSummarySuccess, getClientActionRequiredSummaryFail,
} from './dashboardState';
import createCrudService from '../../services/crudservice';
import { doCrudCall } from '../../utils/crudSagaHelper';

const dashboardService = createCrudService('api/v1/dashboard');

function* getStaffOnlineStatus(data) {	
	yield doCrudCall(
		() => dashboardService.doGetRequest(`staff-online-status`, data.payload), 
		getStaffOnlineStatusSuccess, 
		getStaffOnlineStatusFail);
}

function* getClientSummaryCards(data) {	
	yield doCrudCall(
		() => dashboardService.doGetRequest(`client-summary-cards`, data.payload), 
		getClientSummaryCardsSuccess, 
		getClientSummaryCardsFail);
}

function* getClientActionRequiredSummary(data) {	
	yield doCrudCall(
		() => dashboardService.doGetRequest(`client-action-required-summary`, data.payload), 
		getClientActionRequiredSummarySuccess, 
		getClientActionRequiredSummaryFail);
}

function* dashboardSaga() {
	yield takeLatest('dashboard/getStaffOnlineStatus', getStaffOnlineStatus);
	yield takeLatest('dashboard/getClientSummaryCards', getClientSummaryCards);
	yield takeLatest('dashboard/getClientActionRequiredSummary', getClientActionRequiredSummary);
}

export default dashboardSaga;
